export default __webpack_public_path__ + "static/media/Thumbs.2ea8a246.db";